/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".hey[_ngcontent-%COMP%]{background-image:url(http://getwallpapers.com/wallpaper/full/a/5/d/544750.jpg);color:#fff;background-size:cover;background-repeat:no-repeat;font-family:Numans,sans-serif}"];
export { styles as styles };

